/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { styled, CssBaseline, Collapse } from "@mui/material";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Menu, ExpandLess, ExpandMore } from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutIcon } from "../../assets/images/logout";
import { createCitiesListAction } from "../../redux/action-creators/citiesActionCreator";
import { createOperatorsListAction } from "../../redux/action-creators/operatorActionCreator";
import { removeCookiesOnLogoutUser } from "../../services/login/loginService";
import { extraRoutes } from "../../routing/routes";
import { ConfirmationModal } from "../../shared/widgets";
import { MessageType } from "../../Constant";
import { userLogoutAction } from "../../redux/action-creators/autheritiesActionCreator";
import {
  closedMixin, drawerWidth, menu, openedMixin,
} from "./utils";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme), // Apply the custom styles to .MuiDrawer-paper when open
      color: "white", // Set the text color to black when open,
      backgroundColor: "black",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      margin: 0,
    },
    "& .MuiListItemButton-root": {
      padding: 0,
      display: "flex",
      justifyContent: "space-between",
    },
    "& .MuiListItem-root": {
      display: "block",
      padding: 0,
    },
    "& .MuiListItem-gutters": {
      paddingLeft: 0,
      paddingRight: 10,
    },
    "& .MuiListItemIcon-root": {
      minWidth: 0,
    },
    "& .MuiTypography-root": {
      fontFamily: "'Noto Sans', sans-serif",
    },
    "& .MuiList-padding": {
      paddingTop: 0,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme), // Apply the custom styles to .MuiDrawer-paper when closed
      color: "white", // Set the text color to black when closed
      backgroundColor: "black",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      margin: 0,
    },
    "& .MuiListItemButton-root": {
      padding: 0,
    },
    "& .MuiListItem-root": {
      padding: 0,
    },
    "& .MuiListItem-gutters": {
      paddingLeft: 0,
      paddingRight: 10,
    },
    "& .MuiList-padding": {
      padding: 0,
    },
  }),
}));

const handleExpandClick = ({
  menuKey, activeState: { active, setActive },
  openState: { open, setOpen },
  expandState: { expand, setExpand }, submenuKey,
}) => {
  let submenu = submenuKey;
  if (!submenu && !expand[menuKey]) {
    submenu = active.submenu;
  }
  if (!open) {
    setOpen(true);
  }
  setExpand({ ...expand, [menuKey]: !expand[menuKey] });
  setActive({ menu: menuKey, submenu });
};

// Function to handle menu item click
const handleMenuItemClick = (args) => {
  const {
    menuKey,
    activeState: { setActive },
    openState: { open, setOpen },
    expandState: { expand, setExpand },
    history, submenuKey = null,
  } = args;

  setActive({ menu: menuKey, submenu: submenuKey });
  if (open) {
    setOpen(false);
  }
  setExpand(
    Object.fromEntries(Object.keys(expand).map((key) => [key, false])),
  );
  let routePath = `/${menuKey}`;
  if (submenuKey) {
    routePath += `/${submenuKey}`;
  }
  history.push(routePath);
};

function RenderExpandableListItem(props) {
  const {
    eachItem,
    activeState,
    openState,
    expandState,
    history,
    user,
  } = props;
  const { active } = activeState;
  const { open } = openState;
  const { expand } = expandState;
  return (
    <ListItem
      key={eachItem.key}
      disablePadding
      sx={{ display: "block" }}
    >
      <ListItemButton
        onClick={() => handleExpandClick({
          activeState,
          openState,
          expandState,
          menuKey: eachItem.key,
        })}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            m: "15px",
            justifyContent: "center",
          }}
        >
          {eachItem.icon({
            color:
            eachItem.key === active.menu ? "orange" : "white",
          })}
        </ListItemIcon>
        <ListItemText
          primary={eachItem.name}
          sx={{
          // marginRight: '50px',
            opacity: open ? 1 : 0,
            display: open ? "inherit" : "none",
            color:
            eachItem.key === active.menu ? "orange" : "white", // Set text color to orange when selected, white otherwise
          }}
        />
        <span
          style={{
            display: open ? "inherit" : "none",
          }}
        >
          {expand[eachItem.key] ? <ExpandLess /> : <ExpandMore />}
        </span>
      </ListItemButton>
      <Collapse
        in={expand[eachItem.key]}
        timeout="auto"
        unmountOnExit
      >
        <List
          component="div"
          sx={{
            paddingTop: 0,
          }}
        >
          {eachItem.expandedMenu.map(
            (eachSubItem) => (eachSubItem.auth.length === 0
              || eachSubItem.auth.includes(user.role))
              && (
                <ListItem
                  key={eachSubItem.key}
                  disablePadding
                  sx={{
                    display: "block",
                    marginLeft: "55px",
                    marginBottom: "-15px",
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                    }}
                    selected={active.submenu} // Make the first item selected
                    onClick={() => handleMenuItemClick({
                      menuKey: eachItem.key,
                      activeState,
                      openState,
                      expandState,
                      history,
                      submenuKey: eachSubItem.key,
                    })}
                  >
                    <ListItemText
                      primary={eachSubItem.name}
                      sx={{
                        opacity: expand[eachItem.key] ? 1 : 0,
                        color:
                        eachSubItem.key === active.submenu
                          ? "orange"
                          : "white", // Set text color to orange when selected, white otherwise
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ),
          )}
        </List>
      </Collapse>
    </ListItem>
  );
}

function RenderListItem(props) {
  const {
    eachItem,
    activeState,
    openState,
    expandState,
    history,
    user,
  } = props;
  const { active } = activeState;
  const { open } = openState;
  if (
    eachItem.auth.length === 0
      || eachItem.auth.includes(user.role)
  ) {
    if (eachItem.isExpandable) {
      return (
        <RenderExpandableListItem
          key={eachItem.key}
          eachItem={eachItem}
          activeState={activeState}
          expandState={expandState}
          openState={openState}
          history={history}
          user={user}
        />
      );
    }
    return (
      <ListItem
        key={eachItem.key}
        disablePadding
        sx={{ display: "block" }}
      >
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: "center",
            px: 2.5,
          }}
          selected={active.menu} // Make the first item selected
          onClick={() => handleMenuItemClick({
            menuKey: eachItem.key,
            activeState,
            openState,
            expandState,
            history,
            user,
          })}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              m: "15px",
              justifyContent: "center",
            }}
          >
            {eachItem.icon({
              color:
                    eachItem.key === active.menu ? "orange" : "white",
            })}
          </ListItemIcon>
          <ListItemText
            primary={eachItem.name}
            sx={{
              opacity: open ? 1 : 0,
              color:
                    eachItem.key === active.menu ? "orange" : "white", // Set text color to orange when selected, white otherwise
            }}
          />
        </ListItemButton>
      </ListItem>
    );
  }
  return null;
}

export default function MiniDrawer() {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.Auth.user);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState({
    menu: history?.location?.pathname?.split("/")[1] || "overview",
    submenu: null,
  });
  const [expand, setExpand] = useState({
    report: false,
    "system-config": false,
  });
  const [showConfirmationModal, setModal] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setExpand(
      Object.fromEntries(Object.keys(expand).map((key) => [key, false])),
    );
  };

  const handleLogoutClick = () => {
    setModal(true);
  };

  useEffect(() => {
    dispatch(createCitiesListAction(user, "loader"));
    dispatch(createOperatorsListAction(user, "loader"));
  }, []);

  const updateLoginState = async () => {
    removeCookiesOnLogoutUser()
      .then(() => {
        dispatch(userLogoutAction());
        history.push(extraRoutes.LOGIN);
      })
      .catch((err) => {
        console.log("error while logging out: ", err);
      });
  };

  const displayConfirmationModal = () => (
    <ConfirmationModal
      showModal={showConfirmationModal}
      title="Logout Confirmation"
      content="Are you sure you want to logout?"
      messageCallBack={(type) => {
        if (type === MessageType.SUCCESS) {
          updateLoginState();
        }
        setModal(false);
      }}
    />
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <div>
          <IconButton
            onClick={() => {
              if (!open) handleDrawerOpen();
              else handleDrawerClose();
            }}
            sx={{
              margin: "30px 15px !important",
              color: "white !important",
            }}
          >
            <Menu />
          </IconButton>
          <img
            alt="Logo"
            src="/images/chalo_logo_white.png"
            height="31px"
            width="110px"
            style={{ opacity: open ? 1 : 0 }}
          />
        </div>
        <List
          sx={{
            paddingTop: 0,
          }}
        >
          {menu.map((eachItem) => (
            <RenderListItem
              key={eachItem.key}
              eachItem={eachItem}
              activeState={{ active, setActive }}
              expandState={{ expand, setExpand }}
              openState={{ open, setOpen }}
              history={history}
              user={user}
            />
          ))}
          <ListItem key="logout" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: "center",
                px: 2.5,
              }}
              onClick={() => handleLogoutClick()}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  m: "15px",
                  justifyContent: "center",
                }}
              >
                <LogoutIcon color="#EEE" />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                sx={{
                  opacity: open ? 1 : 0,
                  color: "white", // Set text color to orange when selected, white otherwise
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
      {showConfirmationModal && displayConfirmationModal()}
    </Box>
  );
}
